import React from 'react';

const ImgHTML = ({ src, alt, className, id, style, fetchImmediately }) => {
  return (
    <img
      src={src}
      style={{
        ...style
      }}
      className={`img-fluid ${className}`}
      alt={alt}
      title={alt}
      loading={fetchImmediately ? 'auto' : 'lazy'}
      id={id}
    />
  );
};

export default ImgHTML;

ImgHTML.defaultProps = {
  src: 'https://ulam.io/icons/favicon-96x96.png',
  alt: 'Ulam Labs',
  className: '',
  id: '',
  style: {},
  fetchImmediately: false
};
